// Array to hold all the stock triggers
export const stockTriggers = [
  "An eye roll",
  "A look of annoyance",
  "Negative tone of voice",
  "Walking away",
  "Being loud",
];